module.exports = __webpack_public_path__ + "img/4.462e0278.jpg";